import { IconDefinition } from '@fortawesome/pro-thin-svg-icons';
import { FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import { useTheme } from '@mui/material';
import { FontIcon } from '@resurs-internal/mui';

type Props = {
    icon: FontAwesomeIconProps['icon'] | IconDefinition;
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | undefined;
    color?: string;
};
const Icon = ({ icon, size, color }: Props) => {
    const theme = useTheme();

    return <FontIcon icon={icon as IconDefinition} color={color ? color : theme.palette.primary.main} size={size} />;
};

export default Icon;
